import FirebaseDoc from '../../../abstract/FirebaseDoc';

class InventoryItemState extends FirebaseDoc {
  constructor(root, { snapshot }) {
    super(root, {
      snapshot,
      listenRef: false,
    });
  }
}

InventoryItemState.annotations = {
  ...FirebaseDoc.annotations,
};

export default InventoryItemState;
